export default __webpack_public_path__ + "static/media/allow-withdraw-2.13eb26df.png";